<!-- Created by henian.xu on 2018/7/20. -->

<template>
    <page>
        <!-- 表单区 -->
        <template slot="secondHeader">
            <el-form
                ref="queryForm"
                class="second-header npa-b"
                size="small"
                :inline="true"
                :model="queryFormModel"
            >
                <el-form-item
                    prop="businessDistrictName"
                    label="商业区名称"
                >
                    <el-input
                        v-model="queryFormModel.businessDistrictName"
                        placeholder="请输入商业区名称"
                    />
                </el-form-item>
                <el-form-item
                    prop="businessDistrictStatus"
                    label="商业区状态"
                >
                    <dictionaries-picker
                        type="businessDistrictStatus"
                        v-model="queryFormModel.businessDistrictStatus"
                    />
                </el-form-item>
                <el-form-item
                    prop="isDefault"
                    label="是否默认"
                >
                    <el-select
                        v-model="queryFormModel.isDefault"
                        placeholder="请选择"
                    >
                        <el-option
                            label="全部"
                            value=""
                        />
                        <el-option
                            label="是"
                            value="1"
                        />
                        <el-option
                            label="否"
                            value="0"
                        />
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button
                        type="primary"
                        @click="onQuery()"
                    >
                        查询
                    </el-button>
                    <el-button
                        type="success"
                        @click="onReset"
                    >
                        重置
                    </el-button>
                </el-form-item>
            </el-form>
        </template>

        <!-- 内容 -->
        <div
            class="body"
            slot="body"
            v-loading="querying"
        >
            <!-- 操作 -->
            <div
                class="ma-b"
            >
                <el-button-group>
                    <el-button
                        type="success"
                        icon="el-icon-plus"
                        size="small"
                        @click="$router.push('/sp/businessDistrict/businessDistrict/edit')"
                    >
                        新增
                    </el-button>
                </el-button-group>
            </div>

            <!-- 表格 -->
            <el-table
                stripe
                border
                size="small"
                :data="tableData"
                style="width: 100%"
            >
                <el-table-column
                    prop="businessDistrictName"
                    label="商业区名称"
                    min-width="100"
                />
                <el-table-column
                    prop="businessDistrictSn"
                    label="商业区编号"
                    min-width="100"
                />
                <el-table-column
                    prop="contactFullname"
                    label="联系人姓名"
                    min-width="100"
                />
                <el-table-column
                    prop="contactTel"
                    label="联系人电话"
                    min-width="100"
                />
                <el-table-column
                    label="商业区地址"
                    min-width="100"
                >
                    <template slot-scope="scope">
                        {{ scope.row.regionName }} {{ scope.row.detailAddress }}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="businessDistrictStatusName"
                    label="商业区状态"
                    width="90"
                />
                <el-table-column
                    label="是否默认"
                    width="80"
                >
                    <template slot-scope="scope">
                        {{ scope.row.isDefault ? '是' : '否' }}
                    </template>
                </el-table-column>
                <el-table-column
                    label="创建时间"
                    width="135"
                >
                    <template slot-scope="scope">
                        {{ scope.row.insertTime | moment('YYYY-MM-DD HH:mm:ss') }}
                    </template>
                </el-table-column>
                <el-table-column
                    label="修改时间"
                    width="135"
                >
                    <template slot-scope="scope">
                        {{ scope.row.updateTime | moment('YYYY-MM-DD HH:mm:ss') }}
                    </template>
                </el-table-column>
                <el-table-column
                    fixed="right"
                    label="操作"
                    width="200"
                >
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            size="small"
                            @click="$router.push('/sp/businessDistrict/businessDistrict/edit/' + scope.row.id)"
                        >
                            编辑
                        </el-button>
                        <el-button
                            type="text"
                            size="small"
                            @click="$router.push('/sp/businessDistrict/businessDistrict/store/' + scope.row.id)"
                        >
                            门店管理
                        </el-button>
                        <el-button
                            type="text"
                            size="small"
                            @click="$router.push('/sp/businessDistrict/businessDistrict/serviceTime/' + scope.row.id)"
                        >
                            自取配送设置
                        </el-button>
                        <el-button
                            type="text"
                            size="small"
                            @click="$router.push('/sp/businessDistrict/homeDecoration/' + scope.row.id)"
                        >
                            首页装修
                        </el-button>
                        <el-button
                            type="text"
                            size="small"
                            @click="$router.push('/sp/businessDistrict/activityDecoration/' + scope.row.id)"
                        >
                            活动装修
                        </el-button>
                        <!--                        <el-button
                                                    type="text"
                                                    size="small"
                                                    @click="$router.push('/sp/businessDistrict/adPageDecoration/' + scope.row.id)"
                                                >
                                                    广告装修
                                                </el-button>-->
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="ma-t ta-r">
                <pagination
                    v-model="pagination"
                    @input="onQuery"
                />
            </div>
        </div>
    </page>
</template>

<script>
import pagesMixin from '@/mixin/layout/pageMixin';
import { queryFormList } from 'vmf/src/mixins';

export default {
    name: 'BusinessDistrict',
    mixins: [pagesMixin, queryFormList],
    data() {
        return {
            queryFormModel: {
                businessDistrictName: '', // 商业区名称
                isAvailable: '', // 商业区状态
                businessDistrictStatus: '',
            },
            // 表格数据
            tableData: [],
            // 表格当前选中行
            currentTableSelect: [],
            shareInfoDialog: {
                // 对话框显示
                isVisible: false,
                // 表单数据
                formModel: {
                    id: '',
                    offlineOrderMinAppCodeImage: '',
                },
                // 表单校验规则
                formRules: {},
            },
        };
    },
    methods: {
        /* -- 方法 -- */
        // 请求列表数据
        getListData(queryData) {
            return this.$api.Sp.BusinessDistrict.data({
                ...queryData,
            }).then(json => {
                const res = json.data;
                this.tableData = res.data;
                this.pagination = res.pagination;
                return Promise.resolve(json);
            });
        },
    },
};
</script>

<style lang="scss">
</style>
